import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import AlfaC2cCrossBorderPage from "@/components/AlfaC2cCrossBorderPage.vue";
import {DealStatus} from "@/enum/DealStatus";
import {InvoiceStatus} from "@/enum/InvoiceStatus";
import {FlowType} from "@/enum/FlowType";
import DealDTO from "@/models/DealDTO";
import InvoiceStateDTO from "@/models/InvoiceStateDTO";


export default /*@__PURE__*/_defineComponent({
  __name: 'AlfaCardPreview',
  setup(__props) {

const canceledAt = new Date(Date.now() + 168 * 60 * 60 * 1000).toISOString()

const deal: DealDTO = {
  id: 'preview-deal',
  status: DealStatus.TRANSFER_WAITING,
  paymentMethod: 'alif',
  paymentOption: 'CROSS_BORDER',
  paymentSystem: '',
  requisites: {
    holder: 'BANIMOV SARDOR',
    requisites: '4713 3800 2034 9417',
  },
  canceledAt,
  createdAt: new Date().toISOString(),
  isActive: true,
  disputeAttachment: null,
  isSumChanged: false,
  matchingEmail: null,
}

const invoice: InvoiceStateDTO = {
  id: 'preview-invoice',
  internalId: '48291',
  status: InvoiceStatus.NEW,
  paymentOption: 'CROSS_BORDER',
  crossBorderCurrency: 'TJS',
  sum: {amount: '3120', currency: 'RUB'},
  expiredAt: canceledAt,
  successUrl: null,
  cancelUrl: null,
  isSumChanged: false,
  isTrxIdRequiredForConfirm: false,
  isUserPhoneRequired: false,
  deals: [deal],
  flow: FlowType.ALFAPAY,
  flowData: {
    layout: 'alfa_c2c_cross_border',
  },
}

const cancelDeal = () => undefined
const confirmTransfer = () => undefined

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AlfaC2cCrossBorderPage, {
    "current-deal": deal,
    invoice: invoice,
    cancelDeal: cancelDeal,
    confirmTransfer: confirmTransfer
  }))
}
}

})